import { Checkbox } from '@rbilabs/components-library/build/components/checkbox';
import styled, { css } from 'styled-components';

export const StyledSaveCardContainer = styled.div`
  padding-bottom: 0.5rem;
`;

export const StyledCheckbox = styled(Checkbox)`
  padding: 0 1rem;
`;

export const StyledBillingCityWrapper = styled.div`
  flex-basis: 60%;
  margin-right: 5%;
  ${Styles.desktop`
    flex-basis: 30%;
    margin-right: 5%;
  `}
`;

export const StyledBillingStateWrapper = styled.div`
  flex-basis: 35%;
  ${Styles.desktop`
    flex-basis: 16%;
    margin-right: 5%;
  `}
`;

export const StyledStreetAddressWrapper = styled.div`
  flex-basis: 100%;
`;

export const StyledBillingAptWrapper = styled.div`
  flex-basis: 45%;
  flex-grow: 1;
  ${Styles.desktop`
    flex-basis: 19%;
    margin-right: 5%;
  `}
`;

export const StyledBillingZipWrapper = styled.div`
  flex-basis: 45%;
  flex-grow: 1;
  ${Styles.desktop`
    flex-basis: 20%;
  `}
`;

export const StyledNameOnCardWrapper = styled.div`
  flex-basis: 100%;
`;

export const StyledCountrySelectWrapper = styled.div`
  flex-basis: 100%;
`;

interface IFormContainer {
  withPadding?: boolean;
  withBorder: boolean;
  isHidden?: boolean;
}

export const FormContainer = styled.div<IFormContainer>`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 1rem 0;
  background-color: transparent;
  font-size: 0.75rem;
  visibility: ${p => (p.isHidden ? 'hidden' : 'visible')};

  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  ${Styles.desktop`
    padding: ${({ withPadding }: IFormContainer) => (withPadding ? '1rem' : 0)};

    ${(p: IFormContainer) =>
      p.withBorder &&
      css`
        border: 1px solid ${Styles.color.grey.four};
        background-color: white;
      `}
    `}
`;
